import { CreateFilesModal } from './files-actions-modal'

export const Files = () => {
  return (
    <div className="p-12 bg-white content-container">
      <div className="lg:flex-row lg:justify-between gap-2">
        <div>
          <h3>
            <span className="tracking-wider font-bold text-xl">Files</span>
          </h3>
          <p>
            <span className="tracking-wider font-light">
              Download the Settlement files
            </span>
          </p>
          <br />
        </div>
        <CreateFilesModal />
      </div>
    </div>
  )
}
